import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconPortalGradient(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M16 8.5C15.4477 8.5 15 8.94772 15 9.5C15 10.0523 15.4477 10.5 16 10.5H18C18.5523 10.5 19 10.0523 19 9.5C19 8.94772 18.5523 8.5 18 8.5H16Z"
        fill="url(#paint0_linear_402_5521)"
      />
      <path
        d="M15 12.5C15 11.9477 15.4477 11.5 16 11.5H18C18.5523 11.5 19 11.9477 19 12.5C19 13.0523 18.5523 13.5 18 13.5H16C15.4477 13.5 15 13.0523 15 12.5Z"
        fill="url(#paint1_linear_402_5521)"
      />
      <path
        d="M16 14.5C15.4477 14.5 15 14.9477 15 15.5C15 16.0523 15.4477 16.5 16 16.5H18C18.5523 16.5 19 16.0523 19 15.5C19 14.9477 18.5523 14.5 18 14.5H16Z"
        fill="url(#paint2_linear_402_5521)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 4.5H3C1.89 4.5 1 5.39 1 6.5V18.5C1 19.6 1.89 20.5 3 20.5H8V22.5H16V20.5H21C22.1 20.5 22.99 19.6 22.99 18.5L23 6.5C23 5.39 22.1 4.5 21 4.5ZM3 18.5V6.5H21V18.5H3Z"
        fill="url(#paint3_linear_402_5521)"
      />
      <path
        d="M11 10.5C11 11.6 10.1 12.5 9 12.5C7.9 12.5 7 11.6 7 10.5C7 9.4 7.9 8.5 9 8.5C10.1 8.5 11 9.4 11 10.5Z"
        fill="url(#paint4_linear_402_5521)"
      />
      <path
        d="M11.78 14.08C12.52 14.4 13 15.12 13 15.93V16.5H5V15.93C5 15.12 5.48 14.4 6.22 14.08C7.07 13.71 8.01 13.5 9 13.5C9.99 13.5 10.93 13.71 11.78 14.08Z"
        fill="url(#paint5_linear_402_5521)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_402_5521"
          x1="1"
          y1="4.5"
          x2="24.2339"
          y2="20.7341"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#337FFF" />
          <stop offset="1" stopColor="#E039CE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_402_5521"
          x1="1"
          y1="4.5"
          x2="24.2339"
          y2="20.7341"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#337FFF" />
          <stop offset="1" stopColor="#E039CE" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_402_5521"
          x1="1"
          y1="4.5"
          x2="24.2339"
          y2="20.7341"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#337FFF" />
          <stop offset="1" stopColor="#E039CE" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_402_5521"
          x1="1"
          y1="4.5"
          x2="24.2339"
          y2="20.7341"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#337FFF" />
          <stop offset="1" stopColor="#E039CE" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_402_5521"
          x1="1"
          y1="4.5"
          x2="24.2339"
          y2="20.7341"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#337FFF" />
          <stop offset="1" stopColor="#E039CE" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_402_5521"
          x1="1"
          y1="4.5"
          x2="24.2339"
          y2="20.7341"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#337FFF" />
          <stop offset="1" stopColor="#E039CE" />
        </linearGradient>
      </defs>
    </BaseIcon>
  );
}
